import { useRouter } from "next/router";
import { BlitzPage, Routes } from "@blitzjs/next";
import { SigninForm } from "app/auth/components/SigninForm";

const SigninPage: BlitzPage = () => {
  const router = useRouter();

  return (
    <SigninForm
      onSuccess={async () => {
        const next = router.query.next
          ? decodeURIComponent(router.query.next as string)
          : Routes.PlacemarkIndex();
        await router.push(next);
      }}
    />
  );
};

SigninPage.redirectAuthenticatedTo = "/";
SigninPage.getLayout = (page) => (
  <div className="flex flex-col justify-center items-center gap-y-4 min-h-screen bg-gray-100">
    {page}
  </div>
);

export default SigninPage;
